var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0771 1.21976C11.4189 0.398916 12.5811 0.398916 12.9228 1.21976L15.4687 7.3389C15.6127 7.68502 15.9379 7.92209 16.3115 7.95218L22.918 8.48148C23.8046 8.55256 24.1647 9.65963 23.4892 10.2383L18.4551 14.5498C18.1706 14.7938 18.0468 15.1765 18.1338 15.541L19.6709 21.9873C19.8644 22.7985 19.0494 23.4504 18.3213 23.1465L18.1767 23.0733L12.5215 19.6182C12.2015 19.4227 11.7985 19.4227 11.4785 19.6182L5.82323 23.0733L5.6787 23.1465C4.95054 23.4504 4.13559 22.7985 4.32909 21.9873L5.8662 15.541C5.94232 15.2219 5.85686 14.8892 5.64354 14.6475L5.54491 14.5498L0.51073 10.2383C-0.16474 9.65963 0.195387 8.55256 1.08202 8.48148L7.68846 7.95218C8.06211 7.92209 8.38728 7.68502 8.53124 7.3389L11.0771 1.21976ZM9.916 7.91507C9.55599 8.78066 8.74208 9.37238 7.80761 9.4473L2.3994 9.87991L6.5205 13.4102C7.23232 14.02 7.54349 14.977 7.32616 15.8887L6.06639 21.166L10.6973 18.3379L10.8496 18.252C11.622 17.8515 12.5529 17.8802 13.3027 18.3379L17.9326 21.166L16.6738 15.8887C16.4565 14.977 16.7677 14.02 17.4795 13.4102L21.5996 9.87991L16.1924 9.4473C15.2579 9.37238 14.444 8.78066 14.084 7.91507L12 2.9053L9.916 7.91507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.07690d6154909b4ff7a92f9096bca9a6.svg";
export { ForwardRef as ReactComponent };